import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ColumnsConfigDto, TenantColumnConfigDto } from 'app/models/tenant.model';
import {CdkDragDrop, moveItemInArray, transferArrayItem} from '@angular/cdk/drag-drop';
import { Modules } from 'app/enums/modules.enum';
import { DialogService } from 'app/dialogs/dialog.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-column-order-config',
  templateUrl: './column-order-config.component.html',
  styleUrls: ['./column-order-config.component.scss']
})
export class ColumnOrderConfigComponent implements OnInit {

  columnsConfig:{columnsConfig: ColumnsConfigDto[], defaultColumnsConfig: ColumnsConfigDto[]};
  columns: string[] = [];
  MODULES = Modules;
  moduleId: number;

  constructor(
    public dialogRef: MatDialogRef<ColumnOrderConfigComponent>,
    @Inject(MAT_DIALOG_DATA) public defaultConfig: {columnsConfig: ColumnsConfigDto[],
                                                     defaultColumnsConfig: ColumnsConfigDto[],
                                                     moduleId: number},
    private dialog: DialogService,
    private translate: TranslateService,
  ) { }

  ngOnInit(){

  }

  ngAfterViewInit(): void {
    this.moduleId = this.defaultConfig.moduleId;
    let deafultCols =  {columnsConfig: JSON.parse(JSON.stringify(this.defaultConfig.columnsConfig)), defaultColumnsConfig: JSON.parse(JSON.stringify(this.defaultConfig.defaultColumnsConfig))};
    this.columnsConfig = deafultCols;//Object.assign(this.defaultConfig);
    this.columnsConfig.columnsConfig.map(x => {
      if(x.moduleId == this.MODULES.Alerts){
        if(x.columnDescription.includes('.')){
          x.columnDescription = x.columnDescription.replace('.', '_');
          x.columnDescription = x.columnDescription.toUpperCase();
        }
      }
      this.columns.push(x.columnDescription);
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex,
      );
    };
    
  }

  onConfirm(){
    let msg = this.translate.instant('COLUMNS_ORDER_CONFIG.CONFIRM_APPLY_NEW_CONFIG');
    this.dialog.openConfirmDialog('', msg)
    .afterClosed()
    .subscribe(data => {
      if(data){
        let newColumns: ColumnsConfigDto[] = [];
        this.columns.map(x => {
          let i = this.columns.indexOf(x);
          if(this.moduleId == this.MODULES.Alerts){
            if(x.includes('_')){
              x = x.replace('_', '.');
              x = x.toLocaleLowerCase();
              let arr = x.split('.');
              arr[0] = arr[0].charAt(0).toUpperCase() + arr[0].slice(1);
              arr[1] = arr[1].charAt(0).toUpperCase() + arr[1].slice(1);
              x = arr[0] + "." + arr[1];
            }
          }
          
          let currentColumn = this.defaultConfig.defaultColumnsConfig.find(c => c.columnDescription == x);
          if(!currentColumn){

          }
          newColumns.push({id: currentColumn.id, moduleId: this.moduleId, columnDescription: x, columnOrder: i});
        });
      this.dialogRef.close(newColumns);
      }
    });
  }

  onSetDefaultConfig(){
    let msg = this.translate.instant('COLUMNS_ORDER_CONFIG.CONFIRM_APPLY_DEFAULT_CONFIG');
    this.dialog.openConfirmDialog('', msg)
    .afterClosed()
    .subscribe(data => {
      if(data){
        this.columns = [];
        this.columnsConfig.defaultColumnsConfig.map(x => {
          if(this.moduleId == this.MODULES.Alerts){
            if(x.columnDescription.includes('.')){
              x.columnDescription = x.columnDescription.replace('.', '_');
              x.columnDescription = x.columnDescription.toUpperCase();
            }
          }
          this.columns.push(x.columnDescription);
        });
      }
    });
  }

  onCancel(){
    let msg = this.translate.instant('COLUMNS_ORDER_CONFIG.CONFIRM_CLOSE_MODAL_CONFIG');
    this.dialog.openConfirmDialog('', msg)
    .afterClosed()
    .subscribe(data => {
      if(data){
        this.dialogRef.close();
      }
    });
  }
}
